const state = {
  user: '',
  userEmail: '',
  token: null,
  emailSuccess: '',
  menuAberto: false,
  publicPages: [],
  dadosTransacao: {},
  dadosCompra: {},
  motivosReembolso: [],
  urlAntesLogin: '',
  assinaturaCancelada: '',
  concordouComVendedor: '',
  refreshingTokenPromise: undefined,
  alterarDadosBancarios: false,
  alertaFormaPagamento: [],
  reloadPage: false,
  menuLateral: [],
  afiliadoProdutor: '',
  rastreio: {},
};

export default {
  state,
};
